export default __webpack_public_path__ + "images/right-arrow-light-blue.png?71a12753aea865e570d736d61025b664";